const menu = {
	mobileMenu: function() {
		const burger = document.getElementById('menu-burger');
		const nav = document.querySelector('.mainHeader__nav');
		burger.addEventListener('click', () => {
			burger.classList.toggle('active');
			nav.classList.toggle('active');
		});
		const accountToggler = document.querySelector('.mainHeader__account__toggler');
		const accountWrapper = document.querySelector('.mainHeader__account__wrapper');
		accountToggler.addEventListener('click', () => {
			accountWrapper.classList.toggle('active');
		});
	},
	init: function() {
		if(document.querySelector('.mainHeader')) {
			this.mobileMenu();
		}
	}
}
window.addEventListener('DOMContentLoaded', function(){
    menu.init();
});